import * as pdfjsLib from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export async function renderPdfFirstPageToDataUrl(url, opts = {}) {
  const { scale = 1.2, mime = "image/png" } = opts;
  try {
    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);

    const renderTask = page.render({ canvasContext: ctx, viewport });
    await renderTask.promise;

    return canvas.toDataURL(mime);
  } catch (e) {
    console.error("PDF thumb render failed:", e);
    return null;
  }
}
